import ProfileLayout from "@/components/landing/account/ProfileLayout";
import ProfileSettingsComponent from "@/components/landing/account/settings";
import React from "react";

const ProfileSettings = () => {
    return (
        <ProfileLayout>
            <ProfileSettingsComponent />
        </ProfileLayout>
    )
};

export default ProfileSettings;